// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { Container, Toast } from '@paypalcorp/pp-react'

// REDUX
import { RootState } from '@/redux/store'
import { GLOBAL_REDUCER } from '@/constants'
import { useReduxState } from '@/hooks'
import {
  updateGlobalToast,
  useGlobalDispatch,
} from '@/redux/features/global-slice'

// STYLES
import styles from './styles.module.less'

/**
 * The Layout component wraps the children components in a Container component with global alerts
 * and is meant to be used for consistent appearance and styling
 */
const Layout: React.FC<{
  children: React.ReactNode
  dataTestId?: string
}> = ({ children, dataTestId = '' }) => {
  // STATE
  const { toast } = useReduxState(
    GLOBAL_REDUCER,
  ) as RootState[typeof GLOBAL_REDUCER]

  const dispatch = useGlobalDispatch()
  const removeToast = () => dispatch(updateGlobalToast())

  return (
    <Container
      xxl={true}
      data-testid={dataTestId}
      className={styles.layoutContainer}
    >
      {toast.message && (
        <Toast
          id={toast.message}
          message={toast.message}
          isSuccess={toast.isSuccess !== undefined ? toast.isSuccess : true}
          duration={toast.duration}
          onClose={removeToast}
        />
      )}
      {children}
    </Container>
  )
}

export default Layout
